import { FC } from 'react';
import { ISeriesBooksPage } from '@/interfaces/seriesBooksPage.interface';
import { ABSOLUTE_URL } from '@/helpers/variables';
import { removeAllBrackertsFromString } from '@/helpers/helpers';

interface IBookRatingJsonMarkup {
  data: ISeriesBooksPage;
}

const SeriesJsonMarkup: FC<IBookRatingJsonMarkup> = ({ data }) => {
  const seriesBooks = data.data[0].books_list;

  const books = seriesBooks.map((item) => ({
    '@type': item.type === 'audio_book' ? 'Audiobook' : 'Book',
    name: item.book.title,
    url: `${ABSOLUTE_URL}/avtor/${item.author?.alias}/${item.alias}/`,

    image: `${ABSOLUTE_URL}/covers_200/${item.external_id}.jpg`,
    bookFormat: item.type === 'audio_book' ? 'https://schema.org/AudiobookFormat' : 'https://schema.org/EBook',
  }));

  const getDescription = () => {
    const getBookWithDescription = data.data[0].books_list.find((item) => {
      return item.book.description.length > 1;
    });
    return getBookWithDescription?.book.description || '';
  };

  const serieDescription = getDescription();

  const seriesData = {
    '@context': 'https://schema.org',
    '@type': 'Series',
    name: data.data[0].title,
    description: removeAllBrackertsFromString(serieDescription),
    url: `${ABSOLUTE_URL}/series/${data.data[0].id}/`,
    publisher: {
      '@type': 'Organization',
      name: 'Kuchknig',
    },
    hasPart: books,
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(seriesData, null, 2) }} key="product-jsonld" />;
};

export default SeriesJsonMarkup;
